package co.maytes.standupbot.dashboard.init

import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Typography
import co.maytes.standupbot.shared.design.DesignTokens
import co.maytes.standupbot.shared.design.ThemeScheme
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import org.jetbrains.compose.web.css.CSSMediaQuery
import org.jetbrains.compose.web.css.StyleScope
import org.jetbrains.compose.web.css.px

private fun StyleScope.declareThemeVariables(scheme: ThemeScheme) =
    DesignTokens.cssVariables(scheme).forEach { (name, value) -> property("--$name", value) }

@InitSilk
fun initSiteTheme(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyle("body") {
        base {
            Modifier
                .margin(0.px)
                .fontFamily(*Typography.SANS_STACK)
                .fontSize(Typography.body.size)
                .lineHeight(Typography.body.lineHeight)
                .backgroundColor(Palette.background)
                .color(Palette.textPrimary)
                .styleModifier {
                    property("-webkit-font-smoothing", "antialiased")
                    property("-moz-osx-font-smoothing", "grayscale")
                    property("text-rendering", "optimizeLegibility")

                    declareThemeVariables(ThemeScheme.Light)
                }
        }
        cssRule(
            CSSMediaQuery.Raw("(prefers-color-scheme: dark)"),
            suffix = ":not([data-theme=\"light\"])",
        ) {
            Modifier.styleModifier { declareThemeVariables(ThemeScheme.Dark) }
        }
        cssRule(suffix = "[data-theme=\"dark\"]") {
            Modifier.styleModifier { declareThemeVariables(ThemeScheme.Dark) }
        }
    }

    ctx.stylesheet.registerStyleBase("*") {
        Modifier.styleModifier {
            property("box-sizing", "border-box")
        }
    }

    ctx.stylesheet.registerStyleBase("h1, h2, h3, h4, h5, h6") {
        Modifier.margin(0.px)
    }

    ctx.stylesheet.registerStyleBase("p") {
        Modifier.margin(0.px)
    }

    ctx.stylesheet.registerStyleBase("a") {
        Modifier.styleModifier {
            property("color", "inherit")
            property("text-decoration", "none")
        }
    }

    ctx.stylesheet.registerStyleBase("code, pre, kbd, samp") {
        Modifier.fontFamily(*Typography.MONO_STACK)
    }

    ctx.stylesheet.registerStyleBase("button") {
        Modifier.fontFamily(*Typography.SANS_STACK)
    }

    ctx.stylesheet.registerStyleBase("input, textarea, select") {
        Modifier
            .fontFamily(*Typography.SANS_STACK)
            .fontSize(Typography.body.size)
    }
}
